import React from 'react';

//Styles & Assets
import styles from './ViewFileLink.module.css';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link, To } from 'react-router-dom';

// ViewFileLink: component that renders a Link
//  -id: id of the patient to go to.
const ViewFileLink: React.FC<{
    link: To
}> = ({ link }) => {
    const { t } = useTranslation();

    return (
        <div>
            <Link to={link} className={`anchorButton ${styles.link}`}>
                {t('view_file')}
            </Link>
        </div>
    );
};

export default ViewFileLink;